module.exports = __webpack_public_path__ + "img/checkin_priority.42410c56.png";